import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiRequest } from "src/async/apiUtils";
import MarketingPage from "src/components/landing/MarketingPage";
import Preloader from "src/components/shared/LoadingAnimations/Preloader";
import { useSiteSettings } from "src/context/SiteSettingsContext";

const LandingPage = () => {
  const navigate = useNavigate();
  const { site } = useSiteSettings();
  const [isLoaded, setIsLoaded] = useState(false);
  const [page, setPage] = useState(null);

  const isExtension = window.location.protocol === "chrome-extension:";

  const getPageDetails = async () => {
    try {
      const { data } = await apiRequest("GET", "/portal/landing/page");
      setPage(data.data);
    } catch (err) {
    } finally {
      setIsLoaded(true);
    }
  };

  useEffect(() => {
    if (site?._id) {
      if (site?.use_landing_page) {
        getPageDetails();
      } else {
        setIsLoaded(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [site?._id, site?.use_landing_page]);

  if (isExtension) navigate("/login");

  if (!isLoaded)
    return (
      <div className="h-screen w-full items-center justify-center bg-white">
        <Preloader className="h-full" />
      </div>
    );

  if (!page?._id) navigate("/login");

  return (
    page?._id &&
    (page?.type === "default" ? (
      <div className="relative z-0 w-full bg-white font-normal">
        <MarketingPage
          previewMode
          site={site}
          pageContent={page?.content}
        />
      </div>
    ) : (
      <div dangerouslySetInnerHTML={{ __html: page?.custom_content }} />
    ))
  );
};

export default LandingPage;
